import React from 'react'
import { Box, Flex, Text } from '@workwhile/ui'
import { Link } from 'react-router-dom'
import { AlertTriangle, FileSpreadsheet } from 'lucide-react'
import * as ROUTES from 'constants/routes'
import { Header } from 'components/Header'
import { AccordionCard } from 'components/AccordionCard'

export const Vndly = () => {
  return (
    <>
      <Header title="VNDLY" />
      <Box margin={3}>
        <Flex gap={3} flexWrap="wrap">
          <Link
            to={ROUTES.VNDLY_ISSUES}
            style={{
              textDecoration: 'none',
              maxWidth: 'calc(50% - 0.8rem)',
              width: '100%',
            }}
          >
            <AccordionCard
              title={
                <Flex alignItems="center" gap={2} width="100%">
                  <AlertTriangle size={14} />
                  <Text fontSize={2} color="lightText">
                    Issues
                  </Text>
                </Flex>
              }
            >
              <Text fontSize={2}>
                Resolve VNDLY position, candidate, and work order issues.
              </Text>
            </AccordionCard>
          </Link>
          <Link
            to={ROUTES.VNDLY_COLUMBIA_TIMESHEET}
            style={{
              textDecoration: 'none',
              maxWidth: 'calc(50% - 0.8rem)',
              width: '100%',
            }}
          >
            <AccordionCard
              title={
                <Flex alignItems="center" gap={2} width="100%">
                  <FileSpreadsheet size={14} />
                  <Text fontSize={2} color="lightText">
                    Columbia Timesheet
                  </Text>
                </Flex>
              }
            >
              <Text fontSize={2}>
                Diff a Columbia-approved timesheet CSV against WorkWhile hours.
              </Text>
            </AccordionCard>
          </Link>
        </Flex>
      </Box>
    </>
  )
}
